import React from 'react';
import NavbarAdmin from '../components/NavbarAdmin';

function Admin() {
  return (
    
    <div>
      <div className="head-title">
        My shop
      </div>
      <NavbarAdmin/>
    </div>
  )
}

export default Admin